const IRANIAN_PHONE_NUMBER_REGEX = /^0|[1-9]{2,}[0-9]{8,}$/;
const passwordPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,}$/;
const nationalCodePattern = /^(?!(\d)\1{9})\d{10}$/;
const englishWordsPattern = /^[a-zA-Z\s]+$/;
const persianWordsPattern = /^[\u0600-\u06FF\s]+$/u;
const letterPattern = /^[\p{L}\p{M}\s]+$/u;
const phonePattern =
  /^(\+98|0|98|0098)([ ]|-|[()]){0,2}9\d([ ]|-|[()]){0,2}(?:\d([ ]|-|[()]){0,2}){8}$/;

function isValidNationalCode(code: string | undefined): boolean {
  if (!code) return false;

  const persianToEnglishMap: { [key: string]: string } = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };

  let convertedCode = "";
  for (let char of code) {
    if (persianToEnglishMap[char]) {
      convertedCode += persianToEnglishMap[char];
    } else if (/[0-9]/.test(char)) {
      convertedCode += char;
    } else {
      return false; // Reject non-digit characters
    }
  }

  const L: number = convertedCode.length;

  // Original validation logic
  if (L < 8 || parseInt(convertedCode, 10) === 0) return false;
  convertedCode = ("0000" + convertedCode).slice(L + 4 - 10);
  if (parseInt(convertedCode.slice(3, 9), 10) === 0) return false;

  const c: number = parseInt(convertedCode.slice(9, 10), 10);
  let s: number = 0;

  for (let i = 0; i < 9; i++) {
    s += parseInt(convertedCode.slice(i, i + 1), 10) * (10 - i);
  }

  s = s % 11;

  return (s < 2 && c === s) || (s >= 2 && c === 11 - s);
}

export {
  IRANIAN_PHONE_NUMBER_REGEX,
  nationalCodePattern,
  letterPattern,
  passwordPattern,
  phonePattern,
  englishWordsPattern,
  persianWordsPattern,
  isValidNationalCode,
};
